import React from "react";
import {ImagePicker} from "../../../components/Letflow/Form";
import {TextValidator} from "react-material-ui-form-validator";
import localization from '../../../config/localization';
import TranslatableInputs from "../../../components/Letflow/TranslatableInputs";
import {Checkbox, FormControl, FormControlLabel} from "@material-ui/core";
import {Radio, RadioGroup} from "@material-ui/core/index";

class FormView extends React.Component {

  findMissingFields = () => this.child.findMissingFields()

  render = () => {
    const {
      disabled,
      nameEs,
      nameEn,
      namePt,
      onChange,
      image,
      onImageChange,
      onShowOnSmartSearchChange,
      showOnSmartSearch,
      type,
      synonyms,
      brand,
    } = this.props
    return (
      <div>
        <TranslatableInputs
          ref={instance => this.child = instance}
          children={[
            {
              language: 'es',
              content: [
                <TextValidator
                  style={{width: "100%"}}
                  id="nameEs"
                  label={localization.get('form.name')}
                  name="nameEs"
                  value={nameEs}
                  onChange={onChange}
                  disabled={disabled}
                  validators={['required']}
                  errorMessages={[localization.get('validator.is_required')]}
                />
              ]
            },
            {
              language: 'en',
              content: [
                <TextValidator
                  style={{width: "100%"}}
                  id="nameEn"
                  label={localization.get('form.name')}
                  name="nameEs"
                  value={nameEn}
                  onChange={onChange}
                  disabled={disabled}
                  validators={['required']}
                  errorMessages={[localization.get('validator.is_required')]}
                />
              ]
            },
            {
              language: 'pt',
              content: [
                <TextValidator
                  style={{width: "100%"}}
                  id="namePt"
                  label={localization.get('form.name')}
                  name="namePt"
                  value={namePt}
                  onChange={onChange}
                  disabled={disabled}
                  validators={['required']}
                  errorMessages={[localization.get('validator.is_required')]}
                />
              ]
            },
          ]}
        />
        <TextValidator
          style={{width: "100%"}}
          id="synonyms"
          label={localization.get('form.synonyms')}
          name="synonyms"
          value={synonyms}
          onChange={onChange}
          disabled={disabled}
        />

        <br/>

        {type === "talent" &&
          <FormControl style={{width: "100%", float: "left", position: "relative"}}>
            <span style={{color: "#97877f"}}>{localization.get('form.category_type')}</span>
            <RadioGroup
              name="brand"
              value={brand}
              onChange={e =>
                onChange({
                  target: {
                    id: "brand",
                    value: e.target.value
                  }
                })
              }
              style={{width: '100%', position: "relative", flexDirection: "row"}}
            >
              <FormControlLabel value="bloomclouds" control={<Radio color="default"/>} label={"Creator"}/>
              <FormControlLabel value="bigCreator" control={<Radio color="default"/>} label={"Big Creator"}/>
            </RadioGroup>
          </FormControl>
        }

        <br/>
        <FormControlLabel
          control={
            <Checkbox
              style={{ color: "#4cc2d5" }}
              checked={showOnSmartSearch}
              onChange={() => {
                onShowOnSmartSearchChange(!showOnSmartSearch);
              }}
            />
          }
          label={localization.get("form.show_on_smart_search")}
        />

        <br/>
        <br/>
        <ImagePicker buttonText={localization.get('form.select_image')} image={image && image.src}
                     onImageChange={onImageChange} disabled={disabled}/>
        <div style={{
          color: "#757575",
          textAlign: 'center',
          marginTop: 5
        }}>{localization.get('helper_text.images_recommended', 400)}</div>
      </div>
    )
  }
}

export default FormView